import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card card-body lead text-start" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Thank you for taking the time to determine what financial aid opportunities might be available to you. ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, " Based on your responses you are currently not eligible for any ADHE scholarships at this time. ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" The reason(s) for ineligiblity: ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Please return if your status changes. Click search again if you feel you have received this in error. ")
const _hoisted_6 = { class: "text-center mt-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Search Again")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "/public/login",
  class: "btn btn-secondary ms-2"
}, "Return to SAMS Login", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchPage.getters.eligibilityErrors.value, (e) => {
        return (_openBlock(), _createElementBlock("li", { key: e }, _toDisplayString(e), 1))
      }), 128))
    ]),
    _hoisted_5,
    _createElementVNode("p", _hoisted_6, [
      _createVNode(_component_router_link, {
        class: "btn btn-primary",
        to: {name: 'Public/Search/Home'}
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _hoisted_8
    ])
  ]))
}